module.exports = __webpack_public_path__ + "static/img/cont3611.48599fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3611.jpg
// module id = 5IoZ
// module chunks = 0